import React from 'react';
import { Flex, Text, Relative } from 'pcln-design-system';
import { LinkContainer, LoadMoreContainer } from './LoadMore.styles';
import LoadMoreIcon from './LoadMoreIcon';
const LoadMore = ({
  onLoadMore
}) => {
  return React.createElement(LoadMoreContainer, {
    p: 2
  }, React.createElement(Flex, {
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  }, React.createElement(Relative, {
    textAlign: 'center',
    width: '100%'
  }, React.createElement(LinkContainer, {
    onClick: onLoadMore
  }, React.createElement(LoadMoreIcon, null)), React.createElement(LinkContainer, null, React.createElement(Text, {
    mt: 2,
    fontSize: 2,
    color: 'text.base',
    onClick: onLoadMore
  }, "More Hotels")))));
};
export default LoadMore;